import styled from '@emotion/styled';
import { COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const VisibleLink = styled.a`
  color: ${COLORS.WHITE};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  margin-left: ${SPACING.XS};
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    color: ${COLORS.WHITE};
  }
`;

export const Container = styled.div<{ height: number }>`
  ${FONT.textSizeRegular(FONT.FONT_SIZE_SMALL)}
  max-height: ${({ height }) => height}px;
  transition: max-height 1s;
  background-color: ${COLORS.SHIRAZ_RED};
   // height 0 == published. height 96 == not published
  color: ${({ height }) => (height === 0 ? 'transparent' : COLORS.WHITE)};
    ${VisibleLink} {
    color: ${({ height }) => (height === 0 ? 'transparent' : COLORS.WHITE)};
  }
`;

export const ContentContainer = styled.div`
  padding: ${SPACING.XS} ${SPACING.SM};
  text-align: center;

  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.SM};
  }
`;
